import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const SITE_ORIGIN = "https://gopaperless.quantera.vn";

const getLocale = () =>
  window.location.pathname.startsWith("/vi") ? "vi" : "en";

const upsertMetaByName = (name, content) => {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertMetaByProperty = (property, content) => {
  let el = document.head.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const replaceHreflang = (links) => {
  document.head
    .querySelectorAll('link[rel="alternate"][hreflang]')
    .forEach((el) => el.remove());

  links.forEach(({ lang, href }) => {
    const el = document.createElement("link");
    el.setAttribute("rel", "alternate");
    el.setAttribute("hreflang", lang);
    el.setAttribute("href", href);
    document.head.appendChild(el);
  });
};

const upsertJsonLd = (data) => {
  let el = document.head.querySelector(
    'script[type="application/ld+json"][data-seo-managed="true"]',
  );
  if (!el) {
    el = document.createElement("script");
    el.setAttribute("type", "application/ld+json");
    el.setAttribute("data-seo-managed", "true");
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

const applySeo = () => {
  const locale = getLocale();
  const pagePath = window.location.pathname
    .replace(/^\/(en|vi)(?=\/|$)/, "")
    .replace(/\/$/, "");
  const enUrl = `${SITE_ORIGIN}/en${pagePath}`;
  const viUrl = `${SITE_ORIGIN}/vi${pagePath}`;
  const canonical = locale === "vi" ? viUrl : enUrl;
  const isNoIndex = document.querySelector(".notfound-body") != null;

  document.documentElement.lang = locale;

  upsertMetaByName(
    "robots",
    isNoIndex ? "noindex, follow" : "index, follow",
  );
  upsertCanonical(canonical);
  replaceHreflang([
    { lang: "en", href: enUrl },
    { lang: "vi", href: viUrl },
    { lang: "x-default", href: enUrl },
  ]);
  upsertMetaByProperty("og:url", canonical);

  upsertJsonLd({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${SITE_ORIGIN}/#organization`,
        name: "GoPaperless Quantera",
        url: `${SITE_ORIGIN}/`,
        logo: `${SITE_ORIGIN}/gopaperless.png`,
      },
      {
        "@type": "WebSite",
        "@id": `${SITE_ORIGIN}/#website`,
        url: `${SITE_ORIGIN}/`,
        name: "GoPaperless Quantera",
        inLanguage: ["en", "vi"],
        publisher: { "@id": `${SITE_ORIGIN}/#organization` },
      },
      {
        "@type": "WebPage",
        "@id": `${canonical}#webpage`,
        url: canonical,
        name: document.title || "GoPaperless Quantera",
        inLanguage: locale,
        isPartOf: { "@id": `${SITE_ORIGIN}/#website` },
      },
    ],
  });
};

const SeoHead = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    applySeo();
  }, [location.pathname]);

  useEffect(() => {
    const timer = window.setTimeout(applySeo, 0);
    return () => window.clearTimeout(timer);
  }, [location.pathname]);

  return null;
};

export default SeoHead;
